<!-- Created by henian.xu on 2020/1/1. -->

<template>
    <div class="car-input">
        <div
            v-if="!hide"
            class="out-show"
            @click="onSwitch"
        >
            <div class="inner">
                <template v-for="(item,index) in model">
                    <div
                        :class="['item',{active:currentIndex === index && popupShow}]"
                        :key="`${item}${index}`"
                    >
                        <div class="inner">
                            {{ item }}
                        </div>
                    </div>
                    <div
                        :key="`dot${item}`"
                        v-if="index === 1"
                        class="dot"
                    />
                </template>
            </div>

            <!--<div>{{ model }}</div>
      <div>{{ value }}</div>
      <div>{{ currentIndex }}</div>-->
        </div>

        <!--popup-->
        <transition
            v-if="!lazy"
            name="show"
        >
            <div
                ref="popup"
                class="popup down popup-car-input"
                v-show="popupShow"
                @click.self="close"
            >
                <transition name="popup-down">
                    <div
                        class="inner"
                        v-show="popupShow"
                    >
                        <div class="header">
                            <div />
                            <XButton
                                label="完成"
                                link
                                theme="success"
                                @click="close"
                            />
                        </div>
                        <div class="body">
                            <div class="inner">
                                <div
                                    :class="['item',{disabled:isItemDisabled(item)}]"
                                    v-for="item in options"
                                    :key="item"
                                    @click="onItem(item)"
                                >
                                    <div class="inner">
                                        {{ item }}
                                    </div>
                                </div>
                                <div
                                    v-if="hasNoop"
                                    class="item noop"
                                />
                                <div
                                    class="item delete"
                                    @click="onDelete"
                                >
                                    <div class="inner">
                                        <XIcon content="f008" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import { popupMixin } from 'packages/mixins';

export default {
    name: 'CarInput',
    mixins: [popupMixin],
    data() {
        return {};
    },
    props: {
        value: {
            type: String,
            default: '', // 闽B·8921R
        },
        hide: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        model: {
            get() {
                const { value } = this;
                const valList = value.split('').splice(0, 8);
                const len = valList.length;
                if (len < 8) {
                    const temArr = Array(8 - len).fill('');
                    valList.push(...temArr);
                }
                return valList;
            },
            set(val) {
                this.$emit('input', val.join(''));
            },
        },
        currentIndex() {
            let index = 0;
            const b = this.model.some((item, i) => {
                index = i;
                return !item;
            });
            if (!b) index = 8;
            // return Math.max(index - 1, 0);
            return index;
        },
        hasNoop() {
            const len = this.options.length;
            return !!(len % 39);
        },
        isComplete() {
            return this.currentIndex > 7;
        },
        options() {
            const { currentIndex } = this;
            const p = '京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新临'.split('');
            const c = '1234567890QWERTYUP学军ASDFGHJKL警ZXCVBNM港澳'.split('');
            return !currentIndex ? p : c;
        },
    },
    methods: {
        isItemDisabled(item) {
            const { currentIndex } = this;
            if (currentIndex === 1) {
                return !/[QWERTYUOPASDFGHJKLZXCVBNM]/.test(item);
            }
            if (currentIndex > 1 && currentIndex < 6) {
                return !/[QWERTYUOPASDFGHJKLZXCVBNM1234567890]/.test(item);
            }
            if (currentIndex === 7) {
                return /[学军警港澳]/.test(item);
            }
            return currentIndex > 7;
        },
        onItem(item) {
            const { model, isComplete } = this;
            if (isComplete) return;
            this.model = [...model, item];
        },
        onDelete() {
            const { model, currentIndex } = this;
            const tem = [...model];
            tem.splice(currentIndex - 1, 1, '');
            this.model = tem;
        },
    },
};
</script>

<style lang="scss">
.car-input {
    flex: 1;
    > .out-show {
        background-color: $color-component-bgc;
        overflow: hidden;
        > .inner {
            //margin: $margin-big 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            border: 1px solid $gray5;
            border-radius: $padding-small;
            > .item {
                flex: 1 1 1%;
                + .item {
                    border-left: 1px solid $color-border;
                }
                > .inner {
                    height: 3em;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                }
                &.active {
                    background-color: $color-warning;
                    color: #fff;
                }
            }
            > .dot {
                width: 14px;
                height: 14px;
                background-color: $color-text;
                border-radius: 100vw;
            }
        }
    }
}

.popup.popup-car-input {
    background-color: transparent;
    > .inner {
        > .body {
            padding: $padding-small;
            background-color: $gray2;
            > .inner {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: stretch;
                flex-wrap: wrap;

                > .item {
                    width: 10%;
                    padding: $padding-small/3;
                    &.noop {
                        flex: 1;
                    }
                    &.delete {
                        //width: 20%;
                        > .inner {
                            width: auto;
                        }
                    }
                    &.disabled {
                        color: $gray5;
                    }
                    > .inner {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        height: 2.5em;
                        border: 1px solid $color-border;
                        border-radius: $padding-small;
                        background-color: $color-component-bgc;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>
